import { ASSETS_TYPES, assetsCollectionElement } from '../types'
import { getAssetType } from './getAssetType'

// Typed dialog family (widget.md §Event Catalog): open_<type>_dialog / close_<type>_dialog.
export const assetDialogEvent = (action: 'open' | 'close', asset: assetsCollectionElement) =>
  `${action}_${getAssetType(asset) ?? ASSETS_TYPES.IMAGE}_dialog`
